/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import Cookies from 'js-cookie';
import config from 'loracfg';

const { cookiesPrefix: prefix = '' } = config;

function key(name) {
  return `${prefix}${name}`;
}

export function setCookies(name, value, options) {
  Cookies.set(key(name), value, options);
}

export function getCookies(name) {
  return Cookies.get(key(name));
}

export function getCookiesJSON(name) {
  return Cookies.getJSON(key(name));
}

export function removeCookies(name) {
  return Cookies.remove(key(name));
}




// WEBPACK FOOTER //
// ./src/utils/cookies/index.js